
/* injects from baggage-loader */
require('./style.scss');

import React, { /* useEffect, useRef, useState */ } from 'react';
// import {t} from "../../../helpers/translator";

function Loader () {
    // const LoaderTimeout = 25000;
    // const [timedOut, setTimedOut] = useState(false);
    // const appearTimeout = useRef();

    // useEffect(() => {
    //     appearTimeout.current = setTimeout(() => {
    //         setTimedOut(true);
    //     }, LoaderTimeout);

    //     return () => clearTimeout(appearTimeout.current);
    // }, []);

    // return !timedOut ? (
    //     <div className="md-progress-circular md-theme"/>
    // ) : <div className="md-no-data">
    //     <h2>{t('No data')}</h2>
    //     {/* <button className="button-view-t">{t('Reload')}</button> */}
    // </div>;

    return <div className="md-progress-circular md-theme" />;
}
export default Loader;